/** Env key the Apple Mail server reads its turned-off account ids from */
export const MAIL_BLOCKED_ACCOUNTS_ENV = 'MAIL_BLOCKED_ACCOUNTS';

export interface MailAccount {
  /** The UUID Mail uses for the account directory, uppercase */
  id: string;
  /** Null when Mail could not be asked (Automation denied) */
  name: string | null;
  emails: string[];
}

export type MailAccountsResult =
  | { ok: true; accounts: MailAccount[]; namesUnavailable: boolean }
  | { ok: false; problem: 'full_disk_access' | 'not_installed' | 'failed' };
